module.exports = __webpack_public_path__ + "img/invoice-de-male-st.576cdaec.png";